/** Stable avatar color from name (ui-avatars.com). */
const hashName = (name) => {
  let hash = 0;
  const str = name || "?";
  for (let i = 0; i < str.length; i += 1) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  const color = Math.abs(hash).toString(16).padStart(6, "0").slice(0, 6);
  return color;
};

const generateAvatarUrl = (name) => {
  const backgroundColor = hashName(name);
  return `https://ui-avatars.com/api/?name=${encodeURIComponent(name || "?")}&background=${backgroundColor}&color=ffffff&size=128&bold=true`;
};

export default generateAvatarUrl;
